import { Component } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  showBetaTestingInfo = true;
  public mailBody = `Please list out any issues you have experienced or enhancements you would like to see in
  the tool – if you are referring to a specific page of function of the tool please provide as much detail as
  possible (e.g. Key Data Insights/Filtering to Biscuits/Filtering to 2026-2028)`;

  constructor(public globalService: GlobalService, private router: Router, private route: ActivatedRoute, private authService: AuthService) {
    this.showBetaTestingInfo = environment.showBetaTestingInfo;
  }
}
